import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

/**
 * Attentive is the email subscription provider when PUBLIC_ATTENTIVE.subscriptionEnabled is true.
 * Otherwise the storefront uses Listrak.
 */
export const isAttentiveSubscriptionEnabled = (attentiveConfig) => {
    try {
        const config = attentiveConfig ?? getConfig()?.app?.commerceAPI?.attentive?.config
        if (!config) {
            return false
        }
        return JSON.parse(config).subscriptionEnabled === true
    } catch (e) {
        return false
    }
}

/**
 * Attentive is the email subscription provider when PUBLIC_ATTENTIVE.backInStockEnabled is true.
 * Otherwise the storefront uses Listrak.
 */
export const isAttentiveBackInStockEnabled = (attentiveConfig) => {
    try {
        const config = attentiveConfig ?? getConfig()?.app?.commerceAPI?.attentive?.config
        if (!config) {
            return false
        }
        return JSON.parse(config).backInStockEnabled === true
    } catch (e) {
        return false
    }
}
